import React from "react"
import { useSelector } from "react-redux"
import { selectReport } from "./reportsSlice"
import { COST_AND_USAGE, INVENTORY, TRIAL_BALANCE, GLOBAL_DATA, ACCRUAL, FACILITIES, UNIVERSAL_DATA, MONTH_END_REPORT, CLIENT_FACILITIES, EXCEPTION } from "../../lib/reports"
import CostAndUsage from "./types/CostAndUsage"
import Inventory from "./types/Inventory"
import Exception from "./types/Exception"
import TrialBalance from "./types/TrialBalance"
import GlobalData from "./types/GlobalData"
import UniversalData from "./types/UniversalData"
import MonthEndReport from "./types/MonthEndReport"

import Accrual from "./types/Accrual"
import Facilities from "./types/Facilities"
import ClientFacilities from "./types/ClientFacilities"
export default function ReportFields({ form, actionName }) {
    const report = useSelector(selectReport)

    switch (report?.name) {
        case COST_AND_USAGE:
            return <CostAndUsage />
        case INVENTORY:
            return <Inventory />
        case TRIAL_BALANCE:
            return <TrialBalance />
        case GLOBAL_DATA:
            return <GlobalData form={form} actionName={actionName} />
        case UNIVERSAL_DATA:
            return <UniversalData form={form} actionName={actionName} />    
        case ACCRUAL:
            return <Accrual />
        case FACILITIES:
            return <Facilities />
        case CLIENT_FACILITIES:
            return <ClientFacilities />    
        case MONTH_END_REPORT:
            return <MonthEndReport />
        case EXCEPTION:
            return <Exception />
        default:
            return <Inventory />
            console.error("ERROR: unknown report name: ", report?.name);
            return null
    }
}
